import axios from 'axios'
import router from '../router/router'
import store from '../store/store'
import qs from 'qs'
import {Message} from 'element-ui';


axios.defaults.baseURL = getBaseUrl();

function getBaseUrl() {
    var curWwwPath = window.document.location.href;

    var protocol = window.document.location.protocol;
    var hostname = window.document.location.hostname;
    var host = window.document.location.host;
    var port = window.document.location.port;
    //判断是访问客户端还是后台
    if (curWwwPath.indexOf("8090") >= 0) {
        curWwwPath = protocol + "//" + hostname + ":9290/v1/admin";
    } else {
        curWwwPath = protocol + "//" + hostname + "/v1/admin";
    }
    return curWwwPath;
}

function getImageUrl() {
    var curWwwPath = window.document.location.href;
    var protocol = window.document.location.protocol;
    var hostname = window.document.location.hostname;
    //判断是访问客户端还是后台
    if (curWwwPath.indexOf("8090") >= 0) {
        curWwwPath = protocol + "//" + hostname + ":9290/";

    } else {
        curWwwPath = protocol + "//" + hostname + "/";
    }
    return curWwwPath;
}

axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.interceptors.request.use(
    config => {
        if (store.state.staff) {
            config.headers["Authorization"] = store.state.staff.token;
        }
        if (config.method === 'post' || config.method === 'patch') {
            config.data = qs.stringify(config.data);
        }
        return config;
    },
    error => {
        console.log("err request");
        return Promise.reject(error);
    }
);
var isOutLogin = 0;
axios.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 404:
                    router.push('/notFond')
                    return
                case 500:
                    router.push('/error')
                    // Message.error(error.response.data.message);
                    break;
                case 401:
                    isOutLogin++;
                    if (isOutLogin == 1) {
                        Message.warning("登录超时!");
                    }
                    window.sessionStorage.clear();
                    router.options.routes.splice(2, router.options.routes.length - 2);
                    router.push({path: '/login'});
                    break;
                case 504:
                    window.sessionStorage.clear();
                    router.options.routes.splice(2, router.options.routes.length - 2);
                    router.push({path: '/login'});
                    break;
                case  200:
                    isOutLogin = 0;
                    break;

            }
        }
        if (error.toString().indexOf('timeout') >= 0) {
            Message.warning("请求超时！");
        }
        return Promise.reject(error);
    }
);

//=======================Token=========================
export const getToken = params => {
    return axios.get("/token", {params: params})
};
export const getLogout = id => {
    return axios.get("/logout/" + id)
};
export const imageUrl = url => {
    return getImageUrl() + "Path/" + url;
};


//=======================Permission=========================
export const getPermissionTree = params => {
    return axios.get("/permission-tree", {params: params})
};

export const getMenuTree = params => {
    return axios.get("/menu-tree", {params: params})
};

export const getSubAccountMenuTreeByRoleId = params => {
    return axios.get("/subAccount/menu", {params: params})
};

//=======================toolClass===================
export const getAiaExcel = params => {
    return axios.get("/aiaExcel/query", {params: params})
};
export const updateAiaExcel = data =>{
    return axios.post("/aiaExcel/update",data);
};

//=======================Role=========================
export const getRoleAll = params => {
    return axios.get("/roles", {params: params})
};

export const getRoleList = params => {
    return axios.get("/role", {params: params})
};

export const getRoleById = id => {
    return axios.get("/role/" + id)
};

export const insertRole = data => {
    return axios.post("/role", data)
};

export const updateRole = data => {
    return axios.patch("/role", data)
};

export const deleteRole = id => {
    return axios.delete("/role/" + id)
};

export const getAllRoleList = params => {
    return axios.get("/roleList", {params: params})
};

//=======================Staff=========================
export const queryStaffList = params => {
    return axios.get("/staff", {params: params})
};
//
// export const validLoginName = params => {
//     return axios.get("/staff/valid/loginName", {params: params})
// };
export const validLoginName = params => {
    return axios.get("/staff/valid/loginName/uuid", {params: params})
};
export const insertStaff = data => {
    return axios.post("/staff/insert", data)
};

// export const updateStaff = data => {
//     return axios.post("/staff/update", data)
// };
export const updateStaff = data => {
    return axios.post("/staff/update/uuid", data)
};

// export const queryStaffById = id => {
//     return axios.get("/staff/" + id)
// };
export const queryStaffById = uuid => {
    return axios.get("/staff/uuid/" + uuid)
};
export const queryAllStaffOption = params =>{
    return axios.get("/staff/option",{params: params})
};

export const queryStaffByContractId = contractId =>{
    return axios.get("/staff/contract/"+contractId)
};

export const queryStaffByStaffType = staffType =>{
    return axios.get("/staff/staffType/"+staffType)
};

export const queryPolicyStaffByStaffType = staffType =>{
    return axios.get("/staff/policy/staffType/"+staffType)
};

export const queryOptionMyPolicy = staffId =>{
    return axios.get("/staff/myPolicy/option/partner/"+staffId)
};

export const queryTrOption = staffId =>{
    return axios.get("/staff/myPolicy/option/tr/"+staffId)
};

export const queryTr2Option = staffId =>{
    return axios.get("/staff/myPolicy/option/tr2/"+staffId)
};

export const queryServiceOption = staffId =>{
    return axios.get("/staff/myPolicy/option/service/"+staffId)
};

export const queryOptionStaffLeave = staffId =>{
    return axios.get("/staffLeave/staff/option/"+staffId)
};

export const queryLeaveDays = staffId =>{
    return axios.get("/ecard/staffLeave/"+staffId)
};

export const queryInternalStaffOption = params =>{
    return axios.get("/staff/internal",{params:params});
};

export const querySetSalaryOption = params =>{
    return axios.get("/staff/salary/option",{params:params});
};

export const querySetSalaryOption2 = params =>{
    return axios.get("/staff/salary/option/2",{params:params});
};

export const validPolicyPwd = params =>{
    return axios.get("/staff/pwd/valid/policy",{params:params});
};

export const validSalesPwd = params =>{
    return axios.get("/staff/pwd/valid/sales",{params:params});
};

export const validCommPwd = params =>{
    return axios.get("/staff/pwd/valid/comm",{params:params});
};

export const updateFontSize = data =>{
    return axios.post("/staff/fontSize",data);
};

export const queryStaffInfoByStatus = params =>{
    return axios.get("/staff/option/status",{params:params});
};


export const queryMaxLoginNameByStaffType = params =>{
    return axios.get("/staff/max/login",{params:params});
};

export const querySalarySlipOption = staffId =>{
    return axios.get("/staffSalary/slip/option/"+staffId)
};

export const queryPruCodeByStaffId = staffId =>{
    return axios.get("/get/pruCode/"+staffId)
};


//=======================Contract=========================
export const queryContractList = params => {
    return axios.get("/contract", {params: params})
};

// export const validContractName = params => {
//     return axios.get("/contract/valid/name", {params: params})
// };
export const validContractName = params => {
    return axios.get("/contract/valid/name/uuid", {params: params})
};
export const insertContract = data => {
    return axios.post("/contract/insert", data)
};

// export const updateContract = data =>{
//     return axios.post("/contract/update",data)
// }
export const updateContract = data =>{
    return axios.post("/contract/update/uuid",data)
}
// export const queryContractById = id => {
//     return axios.get("/contract/" + id)
// };
export const queryContractById = uuid => {
    return axios.get("/contract/uuid/" + uuid)
};
export const queryContractOption = params => {
    return axios.get("/contract/option",{params: params})
};



//=======================Group=========================

export const queryGroupList = params => {
    return axios.get("/group",{params: params})
};

export const queryGroupOption = params => {
    return axios.get("/group/option",{params: params})
};

export const insertGroup=data=>{
    return axios.post("/group/insert",data)
};

// export const updateGroup=data=>{
//     return axios.post("/group/update",data)
// };
export const updateGroup=data=>{
    return axios.post("/group/update/uuid",data)
};
// export const validGroupName=params=>{
//     return axios.get("group/valid/name",{params:params});
// };
export const validGroupName=params=>{
    return axios.get("/group/valid/name/uuid",{params:params});
 }
// export const queryGroupById = id=>{
//     return axios.get("/group/"+id);
// };
export const queryGroupById = uuid=>{
    return axios.get("/group/uuid/"+uuid);
};
// export const deleteGroupById = id=>{
//     return axios.get("/group/del/"+id);
// };
export const deleteGroupById = uuid=>{
    return axios.get("/group/del/uuid/"+uuid);
};
export const queryGroupNoPage = params => {
    return axios.get("/group/list",{params: params})
};

// export const updateReportOrdering = data=>{
//     return axios.post("/group/ordering/update",data)
// };
export const updateReportOrdering = data=>{
    return axios.post("/group/ordering/update/uuid",data)
};
export const updateReportOrderingAll = data=>{
    return axios.post("/group/ordering/update/all",data)
};

//=======================Insurance=========================
export const queryInsuranceList = params => {
    return axios.get("/insurance", {params: params})
};

// export const validInsuranceName = params => {
//     return axios.get("/insurance/valid/name", {params: params})
// };
export const validInsuranceName = params => {
    return axios.get("/insurance/valid/name/uuid", {params: params})
};
export const insertInsurance = data => {
    return axios.post("/insurance/insert", data)
};

// export const updateInsurance = data =>{
//     return axios.post("/insurance/update",data)
// }
export const updateInsurance = data =>{
    return axios.post("/insurance/update/uuid",data)
}
// export const queryInsuranceById = id => {
//     return axios.get("/insurance/" + id)
// };
export const queryInsuranceById = uuid => {
    return axios.get("/insurance/uuid/" + uuid)
};

export const queryInsuranceOption = params => {
    return axios.get("/insurance/option",{params: params})
};

export const queryInsuranceAndDisplay = params => {
    return axios.get("/insurance/option/myProduct",{params: params})
};

export const queryInsuranceByUploadId = params => {
    return axios.get("/insurance/uploadId",{params: params})
};


//=======================Currency=========================
export const queryCurrencyList = params => {
    return axios.get("/currency", {params: params})
};

// export const validCurrencyName = params => {
//     return axios.get("/currency/valid/name", {params: params})
// };
export const validCurrencyName = params => {
    return axios.get("/currency/valid/name/uuid", {params: params})
};
export const insertCurrency = data => {
    return axios.post("/currency/insert", data)
};

// export const updateCurrency = data =>{
//     return axios.post("/currency/update",data)
// }
export const updateCurrency = data =>{
    return axios.post("/currency/update/uuid",data)
}

// export const queryCurrencyById = id => {
//     return axios.get("/currency/" + id)
// };
export const queryCurrencyById = uuid => {
    return axios.get("/currency/uuid/" + uuid)
};
export const queryCurrencyOption = params => {
    return axios.get("/currency/option",{params: params})
};
//=======================Product=========================
export const queryProductList = params => {
    return axios.get("/product", {params: params})
};

// export const validProductCode = params => {
//     return axios.get("/product/valid/code", {params: params})
// };
export const validProductCode = params => {
    return axios.get("/product/valid/code/uuid", {params: params})
};
export const insertProduct = data => {
    return axios.post("/product/insert", data)
};

// export const updateProduct = data =>{
//     return axios.post("/product/update",data)
// }
export const updateProduct = data =>{
    return axios.post("/product/update/uuid",data)
}
// export const queryProductById = id => {
//     return axios.get("/product/" + id)
// };
export const queryProductById = uuid => {
    return axios.get("/product/uuid/" + uuid)
};
export const queryProductOption = params => {
    return axios.get("/product/option",{params: params})
};

export const queryProductPeriodOption = params => {
    return axios.get("/product/period/option",{params: params})
};

export const queryByInsuranceIdMyProduct = params => {
    return axios.get("/myProduct/option",{params: params})
};

export const queryPolicyAllProductOption = params => {
    return axios.get("/product/option/limit",{params: params})
};

export const queryProductByFnaAnswer = params => {
    return axios.get("/product/fna",{params: params})
};

export const queryRemoteProductOption = params => {
    return axios.get("/product/option/remote",{params: params})
};


//=======================Customer=========================
export const queryCustomerList = params => {
    return axios.get("/customer", {params: params})
};

// export const validIdNo = params => {
//     return axios.get("/customer/valid/idNo", {params: params})
// };
export const validIdNo = params => {
    return axios.get("/customer/valid/idNo/uuid", {params: params})
};
export const insertCustomer = data => {
    return axios.post("/customer/insert", data)
};

// export const updateCustomer = data =>{
//     return axios.post("/customer/update",data)
// }
export const updateCustomer = data =>{
    return axios.post("/customer/update/uuid",data)
}
// export const queryCustomerById = id => {
//     return axios.get("/customer/" + id)
// };

export const queryCustomerById = uuid => {
    return axios.get("/customer/uuid/" + uuid)
};
export const queryCustomerOption = params => {
    return axios.get("/customer/option",{params: params})
};

export const queryMyCustomerList = params => {
    return axios.get("/my/user/customer",{params: params})
};


//=======================Policy=========================
export const queryPolicyList = params => {
    return axios.get("/policy", {params: params})
};

export const validPolicyNo = params => {
    return axios.get("/policy/valid/policyNo", {params: params})
};

export const insertPolicy = data => {
    return axios.post("/policy/insert", data)
};
//
// export const updatePolicy = data =>{
//     return axios.post("/policy/update",data)
// }

export const updatePolicy = data =>{
    return axios.post("/policy/update/uuid",data)
}

// export const queryPolicyById = id => {
//     return axios.get("/policy/" + id)
// };
export const queryPolicyById = uuid => {
    return axios.get("/policy/uuid/" + uuid)
};
export const queryPolicyOption = params => {
    return axios.get("/policy/option",{params: params})
};

export const queryPolicyByLimit = params => {
    return axios.get("/policy/option/limit",{params: params})
};

export const queryPolicyByTrIdAndMcv = params => {
    return axios.get("/policy/mcv",{params: params})
};

export const queryRenewalNotice = params =>{
    return axios.get("/policy/wechat/renewal",{params:params})
};

export const attachmentPolicyEmail = params =>{
    return axios.get("/policy/email/send",{params:params})
};

export const wechatPolicyInfo = params =>{
    return axios.get("/policy/wechat/info",{params:params})
};

export const queryPolicyNoComm = params =>{
    return axios.get("/policy/comm",{params:params})
};

export const queryMyUserPolicyList = params =>{
    return axios.get("/my/user/policy",{params:params})
};


export const validApplicationNo = params => {
    return axios.get("/policy/valid/applicationNo", {params: params})
};

export const validCustomerOld = params => {
    return axios.get("/policy/valid/customer/age", {params: params})
};


//=======================PolicyHist=========================
export const queryPolicyHistList = params => {
    return axios.get("/policy/hist/list", {params: params})
};

export const queryOnePolicyHistByIdRev = params => {
    return axios.get("/policy/hist/one", {params: params})
};

export const queryCurrentPolicyRevByUuId = uuid => {
    return axios.get("/policy/hist/current/"+uuid)
};


//=======================Remark=========================
export const queryRemarkList = params => {
    return axios.get("/remark", {params: params})
};

export const insertRemark = data => {
    return axios.post("/remark/insert", data)
};

// export const updateRemark = data =>{
//     return axios.post("/remark/update",data)
// }
export const updateRemark = data =>{
    return axios.post("/remark/update/uuid",data)
};
// export const queryRemarkById = id => {
//     return axios.get("/remark/" + id)
// };
export const queryRemarkById = uuid => {
    return axios.get("/remark/uuid/" + uuid)
};
export const queryRemarkOption = params => {
    return axios.get("/remark/option",{params: params})
};

// export const delRemarkById = id => {
//     return axios.post("/remark/delete/"+id)
// };
export const delRemarkById = uuid => {
    return axios.post("/remark/delete/uuid/"+uuid)
};
//=======================CommRate=========================
export const queryCommRateList = params => {
    return axios.get("/commRate", {params: params})
};

// export const validCommRate = params => {
//     return axios.get("/commRate/valid/rate", {params: params})
// };
export const validCommRate = params => {
    return axios.get("/commRate/valid/rate/uuid", {params: params})
};
export const insertCommRate = data => {
    return axios.post("/commRate/insert", data)
};

// export const updateCommRate = data =>{
//     return axios.post("/commRate/update",data)
// }
export const updateCommRate = data =>{
    return axios.post("/commRate/update/uuid",data)
}

// export const queryCommRateById = id => {
//     return axios.get("/commRate/" + id)
// };
export const queryCommRateById = uuid => {
    return axios.get("/commRate/uuid/" + uuid)
};

export const queryCommRateOption = params => {
    return axios.get("/commRate/option",{params: params})
};


//=======================CommStaff=========================
export const queryCommStaffList = params => {
    return axios.get("/commStaff", {params: params})
};

// export const validCommStaff = params => {
//     return axios.get("/commStaff/valid", {params: params})
// };
export const validCommStaff = params => {
    return axios.get("/commStaff/valid/uuid", {params: params})
};
export const insertCommStaff = data => {
    return axios.post("/commStaff/insert", data)
};

// export const updateCommStaff = data =>{
//     return axios.post("/commStaff/update",data)
// };
export const updateCommStaff = data =>{
    return axios.post("/commStaff/update/uuid",data)
};
// export const queryCommStaffById = id => {
//     return axios.get("/commStaff/" + id)
// };
export const queryCommStaffById = uuid => {
    return axios.get("/commStaff/uuid/" + uuid)
};
export const updateCommStaffDetail = data =>{
    return axios.post("/commStaff/detail/update",data)
};

export const commStaffDetailList = commStaffId =>{
    return axios.get("/commStaff/detail/"+commStaffId)
};


export const commStaffCustomList = commStaffId =>{
    return axios.get("/commStaff/custom/"+commStaffId)
};

export const queryCommStaffOrList = params => {
    return axios.get("/commStaff/or", {params: params})
};

export const updateCommStaffOr = data => {
    return axios.post("/commStaff/or/update", data)
};

// export const queryCommStaffOrById = id => {
//     return axios.get("/commStaff/or/" + id)
// };
export const queryCommStaffOrById = uuid => {
    return axios.get("/commStaff/or/uuid/" + uuid)
};
// export const updateOneCommStaffOr = data => {
//     return axios.post("/commStaff/or/updateOne",data)
// };
export const updateOneCommStaffOr = data => {
    return axios.post("/commStaff/or/updateOne/uuid",data)
};

export const commStaffSpecialList   = commStaffId =>{
    return axios.get("/commStaff/special/"+commStaffId)
};

//=======================CommProduct=========================

export const queryCommProductList = params => {
    return axios.get("/commProduct", {params: params})
};


// export const validCommProduct = params => {
//     return axios.get("/commProduct/valid", {params: params})
// };
export const validCommProduct = params => {
    return axios.get("/commProduct/valid/uuid", {params: params})
};
export const insertCommProduct = data => {
    return axios.post("/commProduct/insert", data)
};

// export const updateCommProduct = data =>{
//     return axios.post("/commProduct/update",data)
// };
export const updateCommProduct = data =>{
    return axios.post("/commProduct/update/uuid",data)
};

// export const queryCommProductById = params => {
//     return axios.get("/commProduct/queryOne",{params:params})
// };
export const queryCommProductById = params => {
    return axios.get("/commProduct/queryOne/uuid",{params:params})
};
export const copyProductBasicRate = params => {
    return axios.get("/commProduct/copy",{params:params})
};
export const copyInsuranceCommission = params => {
    return axios.get("/commProduct/insurance/copy",{params:params})
};


//=======================CommRider=========================

export const updateCommRider = data => {
    return axios.post("/commRider/update", data)
};

export const queryCommRiderByProductId = productId =>{
    return axios.get("/commRider/"+productId);
};

export const queryProductByInsuranceId = insuranceId =>{
    return axios.get("/commRider/productList/"+insuranceId);
};

export const queryByInsuranceIdOrderByOption = insuranceId =>{
    return axios.get("/commRider/productList/order/"+insuranceId);
};

//=======================CommProm=========================
export const queryCommPromList = params => {
    return axios.get("/commProm", {params: params})
};

// export const validCommProm = params => {
//     return axios.get("/commProm/valid/name", {params: params})
// };
export const validCommProm = params => {
    return axios.get("/commProm/valid/name/uuid", {params: params})
};
export const insertCommProm = data => {
    return axios.post("/commProm/insert", data)
};

// export const updateCommProm = data =>{
//     return axios.post("/commProm/update",data)
// }
export const updateCommProm = data =>{
    return axios.post("/commProm/update/uuid",data)
}
// export const queryCommPromById = id => {
//     return axios.get("/commProm/" + id)
// };
export const queryCommPromById = uuid => {
    return axios.get("/commProm/uuid/" +uuid)
};
export const queryCommPromOption = params => {
    return axios.get("/commProm/option",{params: params})
};

export const insertCommPromDetail = data =>{
    return axios.post("/commPromDetail/insert",data);
};

export const queryCommPromDetailList = params => {
    return axios.get("/commPromDetail", {params: params})
};



// export const queryOneCommPromDetail = parmas => {
//     return axios.get("/commPromDetail/queryOne",{params: parmas})
// };
export const queryOneCommPromDetail = parmas => {
    return axios.get("/commPromDetail/queryOne/uuid",{params: parmas})
};
// export const updateCommPromDetail = data =>{
//     return axios.post("/commPromDetail/update",data)
// };
export const updateCommPromDetail = data =>{
    return axios.post("/commPromDetail/update/uuid",data)
};
export const queryByCommPromIdGroupByProductId = id => {
    return axios.get("/commPromDetail/product/" + id)
};


export const queryCommPromStaffList = params => {
    return axios.get("/commPromStaff", {params: params})
};

// export const queryOneCommPromStaff = id => {
//     return axios.get("/commPromStaff/" + id)
// };
export const queryOneCommPromStaff = uuid => {
    return axios.get("/commPromStaff/uuid/" + uuid)
};

// export const updateCommPromStaff = data =>{
//     return axios.post("/commPromStaff/update",data)
// };
export const updateCommPromStaff = data =>{
    return axios.post("/commPromStaff/update/uuid",data)
};
// export const delCommPromDetail = commPromDetailId =>{
//     return axios.post("/commPromDetail/del/"+commPromDetailId)
// };
export const delCommPromDetail = uuid =>{
    return axios.post("/commPromDetail/del/uuid/"+uuid)
};

// export const delCommPromStaff = commPromStaffId =>{
//     return axios.post("/commPromStaff/del/"+commPromStaffId)
// };

export const delCommPromStaff = uuid =>{
    return axios.post("/commPromStaff/del/uuid/"+uuid)
};
//=======================Commission=========================
export const commissionDisplay = params =>{
    return axios.get("/comm/display",{params:params});
};

export const queryCommDisplayList = params =>{
    return axios.get("/comm/list",{params:params});
};

export const queryStaffOption = params =>{
    return axios.get("/comm/staff/option",{params:params});
}


//=======================MsgCode=========================
export const insertMsgCode = loginName =>{
    return axios.post("/msgCode/insert/"+loginName);
};

export const validMsgCode = params =>{
    return axios.get("/msgCode/valid",{params:params});
};

export const queryDefaultValidCode = params =>{
    return axios.get("/validCode/query",{params:params});
};

export const updateValidCode = data =>{
    return axios.post("/validCode/update",data);
};



//=======================FileSubType=========================
export const queryFileSubTypeList = params => {
    return axios.get("/fileSubType", {params: params})
};

// export const validFileSubTypeLabel = params => {
//     return axios.get("/fileSubType/valid/label", {params: params})
// };
export const validFileSubTypeLabel = params => {
    return axios.get("/fileSubType/valid/label/uuid", {params: params})
};
export const insertFileSubType = data => {
    return axios.post("/fileSubType/insert", data)
};

// export const updateFileSubType = data =>{
//     return axios.post("/fileSubType/update",data)
// }
export const updateFileSubType = data =>{
    return axios.post("/fileSubType/update/uuid",data)
}

// export const queryFileSubTypeById = id => {
//     return axios.get("/fileSubType/" + id)
// };
export const queryFileSubTypeById = uuid => {
    return axios.get("/fileSubType/uuid/" + uuid)
};
export const queryFileSubTypeOption = type => {
    return axios.get("/fileSubType/option/"+type)
};

//=======================FileUpload=========================
export const policyFileUpload = data =>{
    return axios.post("/fileUpload/policy",data)
};

export const initialPolicyUploadFileList = params =>{
    return axios.get("/file/policy",{params:params})
};

export const delFileById = id =>{
    return axios.post("/file/delete/"+id);
};

export const queryOneUploadFileById = id =>{
    return axios.get("/file/"+id);
};

export const queryListBySourceIdAndType = params =>{
    return axios.get("/file/policy/type",{params:params})
};

export const updateUploadFile = data =>{
    return axios.post("/file/edit",data)
};

export const queryListBySourceIdAndSourceType = params =>{
    return axios.get("/file/list",{params:params})
};

export const counterpointReportPdf = data => {
    return axios.post("/report/pdf/counterpoint",data)
};

export const validMultiUploadFile = params =>{
    return axios.get("/valid/multiUpload",{params:params})
};


//=======================OverseaApplication=========================
export const queryOverseaApplicationList = params => {
    return axios.get("/oversea", {params: params})
};


export const insertOverseaApplication = data => {
    return axios.post("/oversea/insert", data)
};

// export const updateOverseaApplication = data =>{
//     return axios.post("/oversea/update",data)
// }
export const updateOverseaApplication = data =>{
    return axios.post("/oversea/update/uuid",data)
}
// export const queryOverseaApplicationById = id => {
//     return axios.get("/oversea/" + id)
// };
export const queryOverseaApplicationById = uuid => {
    return axios.get("/oversea/uuid/" + uuid)
};
export const overseaApplicationUpdateStatus = data =>{
    return axios.post("/oversea/status",data)
};

export const wechatOverseaApply = params => {
    return axios.get("/oversea/wechat",{params: params})
};
export const updateAdminFees = data =>{
    return axios.post("/oversea/adminFees",data)
};

// export const copyOneOverseaApplication = id => {
//     return axios.get("/oversea/copy/" + id)
// };
export const copyOneOverseaApplication = uuid => {
    return axios.get("/oversea/copy/uuid/" + uuid)
};
export const delOverseaApplication = data =>{
    return axios.post("/oversea/del",data)
};

export const queryHomeMemo = params => {
    return axios.get("/oversea/memo" ,{params:params})
};

export const queryHomeMemoByDate = params => {
    return axios.get("/oversea/memo/query" ,{params:params})
};


export const queryHomeMemoByDateCerted = params => {
    return axios.get("/oversea/memo/query/cert" ,{params:params})
};


export const queryByDateWithCancel = params => {
    return axios.get("/oversea/memo/query/cancel" ,{params:params})
};

export const validPdfDownload = uuid => {
    return axios.get("/oversea/valid/"+uuid)
};


//=======================Holiday=========================
export const queryHolidayList = params => {
    return axios.get("/holiday", {params: params})
};

export const insertHoliday = data => {
    return axios.post("/holiday/insert", data)
};

// export const updateHoliday = data =>{
//     return axios.post("/holiday/update",data)
// }
export const updateHoliday = data =>{
    return axios.post("/holiday/update/uuid",data)
}
export const queryHolidayById = id => {
    return axios.get("/holiday/" + id)
};
export const queryHolidayById2 = uuid => {
    return axios.get("/holiday/uuid/" + uuid)
};
// export const delHoliday = id =>{
//     return axios.post("/holiday/del/"+id)
// };
export const delHoliday = uuid =>{
    return axios.post("/holiday/del/uuid/"+uuid)
};

//=======================StaffLeave=========================
export const queryStaffLeaveList = params => {
    return axios.get("/staffLeave", {params: params})
};

export const insertStaffLeave = data => {
    return axios.post("/staffLeave/insert", data)
};

export const updateStaffLeave = data =>{
    return axios.post("/staffLeave/update",data)
};
export const updateStaffLeave2 = data =>{
    return axios.post("/staffLeave/update/uuid",data)
};
export const queryStaffLeaveById = id => {
    return axios.get("/staffLeave/" + id)
};
export const queryStaffLeaveById2 = uuid => {
    return axios.get("/staffLeave/uuid/" + uuid)
};
export const updateStatus = data =>{
    return axios.post("/staffLeave/status",data)
};

export const queryStaffLeaveSummary = params => {
    return axios.get("/staffLeave/summary", {params: params})
};




//=======================Calendar=========================
export const queryCalendarList = params => {
    return axios.get("/calendar", {params: params})
};

export const queryOneDayCalendarList = params => {
    return axios.get("/calendar/day", {params: params})
};

export const queryOneOversea = overseaId => {
    return axios.get("/calendar/oversea/"+overseaId);
};

export const wechatCalendar = params => {
    return axios.get("/calendar/wechat",{params: params});
};


//=======================MarketInfo=========================
export const queryMarketInfoList = params => {
    return axios.get("/marketInfo", {params: params})
};

export const insertMarketInfo = data => {
    return axios.post("/marketInfo/insert", data)
};

// export const updateMarketInfo = data =>{
//     return axios.post("/marketInfo/update",data)
// };
export const updateMarketInfo = data =>{
    return axios.post("/marketInfo/update/uuid",data)
};
// export const queryMarketInfoById = id => {
//     return axios.get("/marketInfo/" + id)
// };
export const queryMarketInfoById = uuid => {
    return axios.get("/marketInfo/uuid/" + uuid)
};
export const queryMyMarketInfo = params => {
    return axios.get("/marketInfo/my", {params: params})
};

export const queryMarketInfoListNoPage =params =>{
    return axios.get("/marketInfo/library",{params:params})
};

export const sendMarketInfoEmail = params =>{
    return axios.get("/marketInfo/email",{params:params});
};

export const queryWechatMarketInfoById = id => {
    return axios.get("/wechat/marketInfo/" + id)
};


//=======================Info1=========================
export const queryInfo1List = params => {
    return axios.get("/info1", {params: params})
};

export const insertInfo1 = data => {
    return axios.post("/info1/insert", data)
};

// export const updateInfo1 = data =>{
//     return axios.post("/info1/update",data)
// };
export const updateInfo1 = data =>{
    return axios.post("/info1/update/uuid",data)
};
// export const queryInfo1ById = id => {
//     return axios.get("/info1/" + id)
// };
export const queryInfo1ById = uuid => {
    return axios.get("/info1/uuid/" + uuid)
};
export const queryMyInfo1 = params => {
    return axios.get("/info1/my", {params: params})
};

export const queryInfo1ListNoPage =params =>{
    return axios.get("/info1/library",{params:params})
};

export const sendInfo1Email = params =>{
    return axios.get("/info1/email",{params:params});
};

export const queryWechatInfo1ById = id => {
    return axios.get("/wechat/info1/" + id)
};


//=======================Info2=========================
export const queryInfo2List = params => {
    return axios.get("/info2", {params: params})
};

export const insertInfo2 = data => {
    return axios.post("/info2/insert", data)
};

// export const updateInfo2 = data =>{
//     return axios.post("/info2/update",data)
// };
export const updateInfo2 = data =>{
    return axios.post("/info2/update/uuid",data)
};
// export const queryInfo2ById = id => {
//     return axios.get("/info2/" + id)
// };

export const queryInfo2ById = uuid => {
    return axios.get("/info2/uuid/" + uuid)
};
export const queryMyInfo2 = params => {
    return axios.get("/info2/my", {params: params})
};

export const queryInfo2ListNoPage =params =>{
    return axios.get("/info2/library",{params:params})
};

export const sendInfo2Email = params =>{
    return axios.get("/info2/email",{params:params});
};

export const queryWechatInfo2ById = id => {
    return axios.get("/wechat/info2/" + id)
};




//=======================Compliance=========================
export const queryComplianceList = params => {
    return axios.get("/compliance", {params: params})
};

export const insertCompliance = data => {
    return axios.post("/compliance/insert", data)
};

// export const updateCompliance = data =>{
//     return axios.post("/compliance/update",data)
// };
export const updateCompliance = data =>{
    return axios.post("/compliance/update/uuid",data)
};
// export const queryComplianceById = id => {
//     return axios.get("/compliance/" + id)
// };
export const queryComplianceById = uuid => {
    return axios.get("/compliance/uuid/" + uuid)
};
export const updatePublicDate = uuid =>{
    return axios.post("/compliance/public/uuid/" + uuid)
};

export const queryMyCompliance = params => {
    return axios.get("/compliance/my",{params:params})
};

export const queryComplianceReadList = params => {
    return axios.get("/compliance/read",{params:params})
};

export const insertComplianceRead = complianceId => {
    return axios.post("/compliance/read/insert/"+complianceId);
};


export const validByComplianceIdAndStaffId = complianceId => {
    return axios.get("/compliance/read/valid/"+complianceId);
};

export const countUnReadNumber = params => {
    return axios.get("/compliance/unread/count",{params:params});
};

export const queryMyComplianceNoPage = params => {
    return axios.get("/compliance/library",{params:params});
};

export const sendComplianceEmail = params =>{
    return axios.get("/compliance/email",{params:params});
};

//=======================CourseRecord=========================
export const queryCourseRecordList = params => {
    return axios.get("/courseRecord", {params: params})
};

export const insertCourseRecord = data => {
    return axios.post("/courseRecord/insert", data)
};

// export const updateCourseRecord = data =>{
//     return axios.post("/courseRecord/update",data)
// };
export const updateCourseRecord = data =>{
    return axios.post("/courseRecord/update/uuid",data)
};
// export const queryCourseRecordById = id => {
//     return axios.get("/courseRecord/" + id)
// };
export const queryCourseRecordById = uuid => {
    return axios.get("/courseRecord/uuid/" + uuid)
};
export const countHours = params => {
    return axios.get("/courseRecord/count/hours", {params:params});
};


export const querySumHoursByEcardType = params => {
    return axios.get("/fileSubType/count/hours",{params:params});
};


//=======================BusinessGoal=========================
export const queryBusinessGoalList = params => {
    return axios.get("/business/goal", {params: params})
};

export const insertBusinessGoal = data => {
    return axios.post("/business/goal/insert", data)
};

// export const updateBusinessGoal = data =>{
//     return axios.post("/business/goal/update",data)
// };
export const updateBusinessGoal = data =>{
    return axios.post("/business/goal/update/uuid",data)
};
// export const queryBusinessGoalById = id => {
//     return axios.get("/business/goal/" + id)
// };
export const queryBusinessGoalById = uuid => {
    return axios.get("/business/goal/uuid/" + uuid)
};
// export const validBusinessGoal = params => {
//     return axios.get("/business/goal/valid", {params: params})
// };
export const validBusinessGoal = params => {
    return axios.get("/business/goal/valid/uuid", {params: params})
};
//=======================Library=========================
export const queryLibraryList = params => {
    return axios.get("/library", {params: params})
};

export const queryMyLibraryList = params => {
    return axios.get("/library/my", {params: params})
};

export const insertLibrary = data => {
    return axios.post("/library/insert", data)
};

// export const updateLibrary = data =>{
//     return axios.post("/library/update",data)
// };
export const updateLibrary = data =>{
    return axios.post("/library/update/uuid",data)
};
// export const queryLibraryById = id => {
//     return axios.get("/library/" + id)
// };
export const queryLibraryById = uuid => {
    return axios.get("/library/uuid/" + uuid)
};

export const queryLibraryDetailList = params => {
    return axios.get("/library/detail/", {params: params})
};

export const insertLibraryDetail = data => {
    return axios.post("/library/detail/insert", data)
};

// export const updateLibraryDetail = data =>{
//     return axios.post("/library/detail/update",data)
// };
export const updateLibraryDetail = data =>{
    return axios.post("/library/detail/update/uuid",data)
};
// export const queryLibraryDetailById = id => {
//     return axios.get("/library/detail/" + id)
// };
export const queryLibraryDetailById = uuid => {
    return axios.get("/library/detail/uuid/" + uuid)
};
export const queryMyLibraryDetailList = params =>{
    return axios.get("/library/my/detail/",{params:params})
};

// export const delLibraryDetailById = data =>{
//     return axios.post("/library/detail/delete",data)
// };
export const delLibraryDetailById = data =>{
    return axios.post("/library/detail/delete/uuid",data)
};

//=======================SalesReport=========================
export const queryEcardRecord = params =>{
    return axios.get("/salesReport/ecard",{params:params})
}

export const webSalesReport = params =>{
    return axios.get("/salesReport/view",{params:params})
};

export const webMonthlySalesReport = params =>{
    return axios.get("/salesReport/view/monthly",{params:params})
};

//=======================Dashboard=========================
export const dashboardPage = params =>{
    return axios.get("/dashboard",{params:params})
}


//=======================StaffSalary=========================
export const queryStaffSalaryList = params => {
    return axios.get("/staffSalary", {params: params})
};

export const insertStaffSalary = data => {
    return axios.post("/staffSalary/insert", data)
};

// export const updateStaffSalary = data =>{
//     return axios.post("/staffSalary/update",data)
// }
export const updateStaffSalary = data =>{
    return axios.post("/staffSalary/update/uuid",data)
}
// export const queryStaffSalaryById = id => {
//     return axios.get("/staffSalary/" + id)
// };
export const queryStaffSalaryById = uuid => {
    return axios.get("/staffSalary/uuid/" + uuid)
};
// export const staffSalaryUpdateStatus = params => {
//     return axios.get("/staffSalary/approved",{params:params})
// };
export const staffSalaryUpdateStatus = params => {
    return axios.get("/staffSalary/approved/uuid",{params:params})
};
export const queryStaffSalaryOption = params =>{
    return axios.get("/staffSalary/option",{params:params})
};

export const staffSalaryCountTotal = params =>{
    return axios.get("/staffSalary/count/total",{params:params})
};


//=======================SalarySet=========================
export const querySalarySetList = params => {
    return axios.get("/salarySet", {params: params})
};

// export const validSalarySet = params => {
//     return axios.get("/salarySet/valid", {params: params})
// };
export const validSalarySet = params => {
    return axios.get("/salarySet/valid/uuid", {params: params})
};

export const insertSalarySet = data => {
    return axios.post("/salarySet/insert", data)
};

// export const updateSalarySet = data =>{
//     return axios.post("/salarySet/update",data)
// }
export const updateSalarySet = data =>{
    return axios.post("/salarySet/update/uuid",data)
}
// export const querySalarySetById = id => {
//     return axios.get("/salarySet/" + id)
// };
export const querySalarySetById = uuid => {
    return axios.get("/salarySet/uuid/" + uuid)
};
export const querySalarySetOption = params => {
    return axios.get("/salarySet/option", {params: params})
};


export const queryOneByDate = params => {
    return axios.get("/salarySet/valid/one", {params: params})
};





//=======================PolicyComm=========================
export const queryPolicyCommList = params => {
    return axios.get("/policyComm", {params: params})
};

export const insertPolicyComm = data => {
    return axios.post("/policyComm/insert", data)
};
//
// export const updatePolicyComm = data =>{
//     return axios.post("/policyComm/update",data)
// }

export const updatePolicyComm = data =>{
    return axios.post("/policyComm/update/uuid",data)
}
// export const queryPolicyCommById = id => {
//     return axios.get("/policyComm/" + id)
// };
export const queryPolicyCommById = uuid => {
    return axios.get("/policyComm/uuid/" + uuid)
};
export const deletePolicyCommById = data => {
    return axios.post("/policyComm/del",data)
};

export const commissionCalculation = data => {
    return axios.post("/policyComm/cal", data)
};

export const updatePolicyCommStatus = data =>{
    return axios.post("/policyComm/status/update",data)
};

export const batchUpdatePolicyDateCode = data =>{
    return axios.post("/policyComm/dateCode/update",data)
};

export const batchCopy = data =>{
    return axios.post("/policyComm/copy",data)
};

export const queryAutopayList = params => {
    return axios.get("/policyComm/autopay",{params: params})
};

export const confirmPolicyComm = data =>{
    return axios.post("/policyComm/confirm",data)
};


export const validPersonalStatement = params => {
    return axios.get("/report/valid/personal",{params: params})
};

export const queryPolicyCommListByStaffId = params => {
    return axios.get("/policyComm/user/list",{params: params})
};

export const validAutoPay = params => {
    return axios.get("/report/comm/valid/autopay",{params: params})
};


export const validCommissionReceiveExcel = params => {
    return axios.get("/report/valid/comm/rec/excel",{params: params})
};

export const countCourierFees = data => {
    return axios.post("/policyComm/courier/fees",data)
};

export const queryPolicyCourierFeesRecord = params => {
    return axios.get("/policyComm/count/courier/fees",{params: params})
};


export const insertPolicyCommAppr = data => {
    return axios.post("/policyComm/appr/insert", data)
};

export const queryPolicyCommDtoList = params => {
    return axios.get("/policyComm/appr/list", {params: params})
};

export const queryPolicyCommApprByUUId = uuid => {
    return axios.get("/policyComm/appr/uuid/" + uuid)
};

export const queryPolicyCommWithApprByUUId = uuid => {
    return axios.get("/policyComm/with/appr/uuid/" + uuid)
};

export const approvedPolicyCommAppr = uuid => {
    return axios.get("/policyComm/appr/app/" + uuid)
};

export const rejectPolicyCommAppr = uuid => {
    return axios.get("/policyComm/appr/rej/" + uuid)
};



//=======================McvPwd=========================
export const mcvPwdValid = params =>{
    return axios.get("/mcv/valid",{params:params});
};



//=======================StaffWechat=========================
export const queryStaffWechatList = params => {
    return axios.get("/staffWechat", {params: params})
};


export const insertStaffWechat = data => {
    return axios.post("/staffWechat/insert", data)
};

// export const updateStaffWechat = data =>{
//     return axios.post("/staffWechat/update",data)
// }
export const updateStaffWechat = data =>{
    return axios.post("/staffWechat/update/uuid",data)
}
// export const queryStaffWechatById = id => {
//     return axios.get("/staffWechat/" + id)
// };
export const queryStaffWechatById = uuid => {
    return axios.get("/staffWechat/uuid/" + uuid)
};
export const queryAllExistWechat = params =>{
    return axios.get("/staffWechat/exist",{params:params})
};


//=======================McvPolicy=========================
export const queryMcvPolicyList = params => {
    return axios.get("/mcvPolicy", {params: params})
};

export const insertMcvPolicy = data => {
    return axios.post("/mcvPolicy/insert", data)
};

// export const updateMcvPolicy = data =>{
//     return axios.post("/mcvPolicy/update",data)
// };
export const updateMcvPolicy = data =>{
    return axios.post("/mcvPolicy/update/uuid",data)
};
// export const updateMcvPolicyStatus = data =>{
//     return axios.post("/mcvPolicy/status",data)
// };
export const updateMcvPolicyStatus = data =>{
    return axios.post("/mcvPolicy/status/uuid",data)
};
// export const deleteMcvPolicy = data =>{
//     return axios.post("/mcvPolicy/del",data)
// };
export const deleteMcvPolicy = data =>{
    return axios.post("/mcvPolicy/del/uuid",data)
};
export const queryMcvPolicyStaffOption = params =>{
    return axios.get("/mcvPolicy/staff",{params:params})
};


export const queryUnpayMcvPolicyList = params =>{
    return axios.get("/mcvPolicy/salary/staff",{params:params})
};

//=======================Echars=========================
export const queryCommissionReceived = params => {
    return axios.get("/commissionReceived/report/rpp", {params: params})
};
export const queryCommissionReceivedYearly = params => {
    return axios.get("/commissionReceived/report/rpp/yearly", {params: params})
};
export const queryCommissionReceivedUser = params => {
    return axios.get("/commissionReceived/report/rpp/user", {params: params})
};
//
export const queryReceivedUserYearly = params => {
    return axios.get("/commissionReceived/report/rpp/user/yearly", {params: params})
};
export const queryReportUserByStaff = params => {
    return axios.get("/commissionReceived/report/rpp/indiv", {params: params})
};
//=======================SubAccount=========================
export const querySubAccountList = params => {
    return axios.get("/subAccount", {params: params})
};

// export const validSubAccountLoginName = params => {
//     return axios.get("/subAccount/valid/loginName", {params: params})
// };
export const validSubAccountLoginName = params => {
    return axios.get("/subAccount/valid/loginName/uuid", {params: params})
};
export const insertSubAccount = data => {
    return axios.post("/subAccount/insert", data)
};

// export const updateSubAccount = data =>{
//     return axios.post("/subAccount/update",data)
// }
export const updateSubAccount = data =>{
    return axios.post("/subAccount/update/uuid",data)
}

// export const querySubAccountById = id => {
//     return axios.get("/subAccount/" + id)
// };
export const querySubAccountById = uuid => {
    return axios.get("/subAccount/uuid/" + uuid)
};
//=======================CoverMst=========================
export const queryCoverMstList = params => {
    return axios.get("/dataFeed/policy/list", {params: params})
};

export const queryOneCoverMstByFactor = params => {
    return axios.get("/dataFeed/policy", {params: params})
};

//=======================QuestionnaireList=========================
export const insertSurvey = data => {
    return axios.post("/survey/insert", data)
};
export const querySurveyList = params =>{
    return axios.get("/survey",{params:params})
};
export const querySurveyById = id =>{
    return axios.get("/survey/"+id)
};
export const querySurveyById2 = uuid =>{
    return axios.get("/survey/uuid/"+uuid)
};
// export const updateSurvey = data => {
//     return axios.post("/survey/update", data)
// };
export const updateSurvey = data => {
    return axios.post("/survey/update/uuid", data)
};
export const updateSurveyResult = data => {
    return axios.post("/surveyResult/update", data)
};
export const queryListBySurveyId = params =>{
    return axios.get("/surveyResult/one",{params:params})
};
// /survey/option
export const querySurveyOption = params =>{
    return axios.get("/survey/option/",{params:params})
};
export const queryOneByPoint = data =>{
    return axios.post("/surveyResult/point",data)
};
export const querySurveyUser = params =>{
    return axios.get("/surveyUser",{params:params})
};
export const queryUserDetail = params =>{
    return axios.get("/surveyUserDetail",{params:params})
};
//=======================Proposal=========================
export const queryProposalList = params => {
    return axios.get("/proposal", {params: params})
};

export const insertProposal = data => {
    return axios.post("/proposal/insert", data)
};

// export const updateProposal = data =>{
//     return axios.post("/proposal/update",data)
// }
export const updateProposal = data =>{
    return axios.post("/proposal/update/uuid",data)
}
// export const queryProposalById = id => {
//     return axios.get("/proposal/" + id)
// };
export const queryProposalById = uuid => {
    return axios.get("/proposal/uuid/" + uuid)
};
// export const delProposalById = id => {
//     return axios.post("/proposal/delete/" + id)
// };queryProposalById
export const delProposalById = uuid => {
    return axios.post("/proposal/delete/uuid/" + uuid)
};

//=======================DateCode=========================
export const queryDateCodeList = params => {
    return axios.get("/dateCode", {params: params})
};

// export const validDateCode = params => {
//     return axios.get("/dateCode/valid", {params: params})
// };
export const validDateCode = params => {
    return axios.get("/dateCode/valid/uuid", {params: params})
};
export const insertDateCode = data => {
    return axios.post("/dateCode/insert", data)
};

// export const updateDateCode = data =>{
//     return axios.post("/dateCode/update",data)
// }
export const updateDateCode = data =>{
    return axios.post("/dateCode/update/uuid",data)
}
// export const queryDateCodeById = id => {
//     return axios.get("/dateCode/" + id)
// };
export const queryDateCodeById = uuid => {
    return axios.get("/dateCode/uuid/" + uuid)
};



//=======================Node=========================
export const getNodeAll = params => {
    return axios.get("/nodes", {params: params})
};

export const getNodeList = params => {
    return axios.get("/node", {params: params})
};

export const getNodeById = id => {
    return axios.get("/node/" + id)
};

export const insertNode = data => {
    return axios.post("/node", data)
};

export const updateNode = data => {
    return axios.patch("/node", data)
};

export const deleteNode = id => {
    return axios.delete("/node/" + id)
};

//=======================DataFeedTemp=========================
export const policyCvsSave = data => {
    return axios.post("/policyCvsSave", data)
};

export const queryDataFeedTempList = params => {
    return axios.get("/queryDataFeedTemp", {params: params})
};

export const queryDataFeedTempConList = params => {
    return axios.get("/queryDataFeedTempCon", {params: params})
};

export const queryDataFeedTempOption = params => {
    return axios.get("/dataFeedTemp/option",{params: params})
};

export const weixinScanLogin = params => {
    return axios.get("/weixinScanLogin", {params: params})
};

export const checkScan = params => {
    return axios.get("/checkScan", {params: params})
};

export const weixinSweepCode = params => {
    return axios.get("/weixinSweepCode", {params: params})
};

//======================ToolClass=============================
//
export const getApiList = params => {
    return axios.get("/apiSet/list", params)
};
export const updateApiList = data => {
    return axios.post("/apiSet/update", data)
};

//=======================RoomBooking=========================
export const queryRoomBookingList = params => {
    return axios.get("/roomBooking", {params: params})
};


export const insertRoomBooking = data => {
    return axios.post("/roomBooking/insert", data)
};

// export const updateRoomBooking = data =>{
//     return axios.post("/roomBooking/update",data)
// };
export const updateRoomBooking = data =>{
    return axios.post("/roomBooking/update/uuid",data)
};

export const queryRoomBookingById = id => {
    return axios.get("/roomBooking/" + id)
};
export const queryRoomBookingById2 = uuid => {
    return axios.get("/roomBooking/uuid/" + uuid)
};


//=======================Countrtpoint=========================
export const insertPdfDataPosition = data => {
    return axios.post("/countrtpoint/insert", data)
};

export const queryPdfDataPosition = params => {
    return axios.get("/countrtpoint/pdfDataPosition", {params: params})
};


//=======================pdfMatchAll=========================
export const pdfMatchAll = params => {
    return axios.get("/pdfMatchAll", {params: params})
};

//=======================UploadInsurance=========================
export const insertUploadInsurance = data => {
    return axios.post("/uploadInsurance/insert", data)
};

export const deleteUploadInsurance = data => {
    return axios.post("/uploadInsurance/delete", data)
};

//=======================Questionnaire=========================
export const queryProjectContentList = params => {
    return axios.get("/projectContent", {params: params})
};

export const queryQuestionnaireOpinionsList = params => {
    return axios.get("/questionnaireOpinions", {params: params})
};

export const queryProjectContentAll = params => {
    return axios.get("/projectContentAll" ,{params: params})
};

export const insertProjectContent = data => {
    return axios.post("/projectContent/insert", data)
};

// export const updateProjectContent = data =>{
//     return axios.post("/projectContent/update",data)
// }
export const updateProjectContent = data =>{
    return axios.post("/projectContent/update/uuid",data)
}
// export const delProjectContent = id => {
//     return axios.post("/projectContent/delete/"+id)
// };
export const delProjectContent = uuid => {
    return axios.post("/projectContent/delete/uuid/"+uuid)
};
export const insertQuestionnaire = data => {
    return axios.post("/questionnaire/insert" ,data)
};

// export const queryQuestionnaireOpinionsById = id => {
//     return axios.get("/questionnaireOpinions/" + id)
// };
export const queryQuestionnaireOpinionsById = uuid => {
    return axios.get("/questionnaireOpinions/uuid/" + uuid)
};
// export const queryQuestionnaireById = id => {
//     return axios.get("/questionnaire/" + id)
// };
export const queryQuestionnaireById = uuid => {
    return axios.get("/questionnaire/uuid/" + uuid)
};
// export const updateQuestionnaireOpinions = data => {
//     return axios.post("/questionnaireOpinions/update" ,data)
// };
export const updateQuestionnaireOpinions = data => {
    return axios.post("/questionnaireOpinions/update/uuid" ,data)
};
// export const updateQuestionnaire = data => {
//     return axios.post("/questionnaire/update" ,data)
// };
export const updateQuestionnaire = data => {
    return axios.post("/questionnaire/update/uuid" ,data)
};

// export const delQuestionnaireOpinions = id => {
//     return axios.post("/questionnaireOpinions/delete/"+id)
// };
export const delQuestionnaireOpinions = uuid => {
    return axios.post("/questionnaireOpinions/delete/uuid/"+uuid)
};
// export const delQuestionnaire = id => {
//     return axios.post("/questionnaire/delete/"+id)
// };

export const delQuestionnaire = uuid => {
    return axios.post("/questionnaire/delete/uuid/"+uuid)
};
export const queryQuestionnaireList = params => {
    return axios.get("/questionnaire", {params: params})
};



//=======================McvFeesOr=========================
export const queryMcvFeesOrList = params => {
    return axios.get("/mcvFees/or", {params: params})
};


export const insertMcvFeesOr = data => {
    return axios.post("/mcvFees/or/insert", data)
};

// export const updateMcvFeesOr = data =>{
//     return axios.post("/mcvFees/or/update",data)
// };
export const updateMcvFeesOr = data =>{
    return axios.post("/mcvFees/or/update/uuid",data)
};

// export const queryMcvFeesOrById = id => {
//     return axios.get("/mcvFees/or/" + id)
// };
export const queryMcvFeesOrById = uuid => {
    return axios.get("/mcvFees/or/uuid/" + uuid)
};
export const mcvFeesOrHandle = data =>{
    return axios.post("/mcvFees/or/handle",data)
};

export const queryMcvFeesOrMatchList = params => {
    return axios.get("/mcvFees/or/query",{params:params} )
};



//=======================CommHist=========================
export const queryCommHistPList = params => {
    return axios.get("/commHist", {params: params})
};


export const insertCommHist = data => {
    return axios.post("/commHist/insert", data)
};

// export const updateCommHist = data =>{
//     return axios.post("/commHist/update",data)
// };
export const updateCommHist = data =>{
    return axios.post("/commHist/update/uuid",data)
};
// export const queryCommHistById = id => {
//     return axios.get("/commHist/" + id)
// };
export const queryCommHistById = uuid => {
    return axios.get("/commHist/uuid/" + uuid)
};

export const queryCommHistListByInsurance = params => {
    return axios.get("/commHist/list/insurance", {params: params})
};



//=======================CommHist=========================
export const queryStaffCommHistPList = params => {
    return axios.get("/staffCommHist", {params: params})
};


export const insertStaffCommHist = data => {
    return axios.post("/staffCommHist/insert", data)
};

// export const updateStaffCommHist = data =>{
//     return axios.post("/staffCommHist/update",data)
// };
export const updateStaffCommHist = data =>{
    return axios.post("/staffCommHist/update/uuid",data)
};

// export const queryStaffCommHistById = id => {
//     return axios.get("/staffCommHist/" + id)
// };
export const queryStaffCommHistById = uuid => {
    return axios.get("/staffCommHist/uuid/" + uuid)
};
export const queryStaffCommHistListByInsurance = params => {
    return axios.get("/staffCommHist/list/staff", {params: params})
};


//=======================ReportApply=========================
export const queryReportApplyList = params => {
    return axios.get("/reportApply", {params: params})
};


export const insertReportApply = data => {
    return axios.post("/reportApply/insert", data)
};

export const updateReportApply = data =>{
    return axios.post("/reportApply/update",data)
};

// export const queryReportApplyById = id => {
//     return axios.get("/reportApply/" + id)
// };
export const queryReportApplyById = uuid => {
    return axios.get("/reportApply/uuid/" + uuid)
};
export const dledReport = data =>{
    return axios.post("/reportApply/dl/update",data)
};

//=======================Wechat=========================
export const policyMessage = params => {
    return axios.get("/wechat/message/policy", {params: params})
};


export const overseaApplyMessage = params => {
    return axios.get("/wechat/oversea/confirm/message", {params: params})
};


//=======================ManagerMeeting=========================
export const queryManagerMeetingList = params => {
    return axios.get("/managerMeeting", {params: params})
};

export const insertManagerMeeting = data => {
    return axios.post("/managerMeeting/insert", data)
};

// export const updateManagerMeeting = data =>{
//     return axios.post("/managerMeeting/update",data)
// }
export const updateManagerMeeting = data =>{
    return axios.post("/managerMeeting/update/uuid",data)
}
// export const queryManagerMeetingById = id => {
//     return axios.get("/managerMeeting/" + id)
// };
export const queryManagerMeetingById = uuid => {
    return axios.get("/managerMeeting/uuid/" + uuid)
};
//=======================SendEmail=========================
export const querySendEmailList = params => {
    return axios.get("/sendEmail", {params: params})
};

// export const querySendEmailById = id => {
//     return axios.get("/sendEmail/" + id)
// };
export const querySendEmailById = uuid => {
    return axios.get("/sendEmail/uuid/" + uuid)
};


//=======================ProductTrain=========================
export const queryProductTrainList = params => {
    return axios.get("/productTrain", {params: params})
};

export const insertProductTrain = data => {
    return axios.post("/productTrain/insert", data)
};

// export const updateProductTrain = data =>{
//     return axios.post("/productTrain/update",data)
// };
export const updateProductTrain = data =>{
    return axios.post("/productTrain/update/uuid",data)
};
// export const queryProductTrainById = id => {
//     return axios.get("/productTrain/" + id)
// };
export const queryProductTrainById = uuid => {
    return axios.get("/productTrain/uuid/" + uuid)
};
export const updateProductTrainPublicDate = id =>{
    return axios.post("/productTrain/public/" + id)
};

export const queryMyProductTrain = params => {
    return axios.get("/productTrain/my",{params:params})
};

export const queryProductTrainReadList = params => {
    return axios.get("/productTrain/read",{params:params})
};

export const insertProductTrainRead = productTrainId => {
    return axios.post("/productTrain/read/insert/"+productTrainId);
};


export const validByProductTrainIdAndStaffId = productTrainId => {
    return axios.get("/productTrain/read/valid/"+productTrainId);
};

export const countProductTrainUnReadNumber = params => {
    return axios.get("/productTrain/unread/count",{params:params});
};


export const queryMyProductTrainNoPage = params => {
    return axios.get("/productTrain/library",{params:params});
};

export const sendProductTrainEmail = params =>{
    return axios.get("/productTrain/email",{params:params});
};





//=======================Memo=========================
export const queryMemoList = params => {
    return axios.get("/memo", {params: params})
};

export const insertMemo = data => {
    return axios.post("/memo/insert", data)
};

// export const updateMemo = data =>{
//     return axios.post("/memo/update",data)
// };
export const updateMemo = data =>{
    return axios.post("/memo/update/uuid",data)
};
// export const queryMemoById = id => {
//     return axios.get("/memo/" + id)
// };
export const queryMemoById = uuid => {
    return axios.get("/memo/uuid/" + uuid)
};
// export const updateMemoPublicDate = id =>{
//     return axios.post("/memo/public/" + id)
// };
export const updateMemoPublicDate = uuid =>{
    return axios.post("/memo/public/uuid/" + uuid)
};
export const queryMyMemo = params => {
    return axios.get("/memo/my",{params:params})
};

export const queryMemoReadList = params => {
    return axios.get("/memo/read",{params:params})
};

export const insertMemoRead = memoId => {
    return axios.post("/memo/read/insert/"+memoId);
};


export const validByMemoIdAndStaffId = memoId => {
    return axios.get("/memo/read/valid/"+memoId);
};

export const countMemoUnReadNumber = params => {
    return axios.get("/memo/unread/count",{params:params});
};


export const queryMyMemoNoPage = params => {
    return axios.get("/memo/library",{params:params});
};

export const sendMemoEmail = params =>{
    return axios.get("/memo/email",{params:params});
};




//=======================StaffMemo=========================
export const queryStaffMemoList = params => {
    return axios.get("/staffMemo", {params: params})
};

export const insertStaffMemo = data => {
    return axios.post("/staffMemo/insert", data)
};

// export const updateStaffMemo = data =>{
//     return axios.post("/staffMemo/update",data)
// };
export const updateStaffMemo = data =>{
    return axios.post("/staffMemo/update/uuid",data)
};

// export const queryStaffMemoById = id => {
//     return axios.get("/staffMemo/" + id)
// };
export const queryStaffMemoById = uuid => {
    return axios.get("/staffMemo/uuid/" + uuid)
};
// export const updateStaffMemoPublicDate = id =>{
//     return axios.post("/staffMemo/public/" + id)
// };
export const updateStaffMemoPublicDate = uuid =>{
    return axios.post("/staffMemo/public/uuid/" + uuid)
};
export const queryMyStaffMemo = params => {
    return axios.get("/staffMemo/my",{params:params})
};

export const queryStaffMemoReadList = params => {
    return axios.get("/staffMemo/read",{params:params})
};

export const insertStaffMemoRead = productTrainId => {
    return axios.post("/staffMemo/read/insert/"+productTrainId);
};


export const validByStaffMemoIdAndStaffId = productTrainId => {
    return axios.get("/staffMemo/read/valid/"+productTrainId);
};

export const countStaffMemoUnReadNumber = params => {
    return axios.get("/staffMemo/unread/count",{params:params});
};


export const queryMyStaffMemoNoPage = params => {
    return axios.get("/staffMemo/library",{params:params});
};

export const sendStaffMemoEmail = params =>{
    return axios.get("/staffMemo/email",{params:params});
};






//=======================CommissionSchedule=========================
export const insertCommissionSchedule = data => {
    return axios.post("/commission/schedule/insert",data);
};

export const queryCommissionSchedule = params =>{
    return axios.get("/commission/schedule/list",{params:params});
};


//=======================CsComment=========================
export const insertCsComment = data => {
    return axios.post("/cs/comment/insert",data);
};

export const queryCsComment = params =>{
    return axios.get("/cs/comment/list",{params:params});
};




//=======================SmsMsg=========================
export const querySmsMsgList = params => {
    return axios.get("/smsMsg/list", {params: params})
};


export const insertSmsMsg = data => {
    return axios.post("/smsMsg/insert", data)
};

// export const updateSmsMsg = data =>{
//     return axios.post("/smsMsg/update",data)
// };
export const updateSmsMsg = data =>{
    return axios.post("/smsMsg/update/uuid",data)
};
// export const querySmsMsgById = id => {
//     return axios.get("/smsMsg/" + id)
// };
export const querySmsMsgById = uuid => {
    return axios.get("/smsMsg/uuid/" + uuid)
};
export const sendHkMobile = id => {
    return axios.get("/smsMsg/send/" + id)
};


export const getSmsMsgRecord = id => {
    return axios.get("/smsMsg/send/record/" + id)
};


export const getOneSmsMsgRecord = id => {
    return axios.get("/smsMsg/send/record/one/" + id)
};

export const pendingSmsSend = params => {
    return axios.get("/smsMsg/send/policy/pending",{params: params})
};


//=======================DataFeed=========================
export const queryDataFeedList = params => {
    return axios.get("/dataFeed", {params: params})
};

export const insertDataFeed = data => {
    return axios.post("/dataFeed/insert", data)
};

export const queryDatafeedById = id => {
    return axios.get("/dataFeed/" + id)
};


export const dataFeedCancel = uuid => {
    return axios.post("/dataFeed/cancel/" + uuid)
};

export const updatePolicyInfo = uuid => {
    return axios.post("/dataFeed/policy/update/all/" + uuid)
};


//=======================DataFeedLogBook=========================
export const queryDataFeedLogBookList = params => {
    return axios.get("/dataFeed/log", {params: params})
};

//=======================PlanCodeMatch=========================
export const queryPlanCodeMatchList = params => {
    return axios.get("/planCodeMatch", {params: params})
};

export const insertPlanCodeMatch = data => {
    return axios.post("/planCodeMatch/insert", data)
};
//
// export const updatePlanCodeMatch = data =>{
//     return axios.post("/planCodeMatch/update",data)
// };

export const updatePlanCodeMatch = data =>{
    return axios.post("/planCodeMatch/update/uuid",data)
};
// export const queryPlanCodeMatchById = id => {
//     return axios.get("/planCodeMatch/" + id)
// };
export const queryPlanCodeMatchById = uuid => {
    return axios.get("/planCodeMatch/uuid/" + uuid)
};
export const getPolicyFieldValue = params => {
    return axios.get("/dataFeed/policy/find/field", {params: params})
};
export const updateOnePolicyInfo = data => {
    return axios.post("/dataFeed/policy/update/one",data)
};

//=======================CommissionReceived=========================
export const queryCommissionReceivedList = params => {
    return axios.get("/commissionReceived", {params: params})
};

export const insertCommissionReceived = data => {
    return axios.post("/commissionReceived/insert", data)
};

export const updateCommissionReceived = data =>{
    return axios.post("/commissionReceived/update/",data)
};

export const queryCommissionReceivedByUuid = uuid => {
    return axios.get("/commissionReceived/" + uuid)
};

export const queryCommissionReceivedByLogUuid = uuid => {
    return axios.get("/commissionReceived/log/" + uuid)
};

export const deleteCommissionReceivedByUuid = uuid => {
    return axios.post("/commissionReceived/del/" + uuid)
};


export const queryCommRecImportExcelList = params => {
    return axios.get("/commissionReceived/excel/list", {params: params})
};

export const queryCommRecImportExcelByUuid = uuid => {
    return axios.get("/commissionReceived/excel/" + uuid)
};

export const updateCommRecExcel = data =>{
    return axios.post("/commissionReceived/excel/update",data)
};

export const readCommRecExcel = uuid => {
    return axios.get("/commissionReceived/excel/read/" + uuid)
};


export const confirmInsertCommRecExcel = uuid =>{
    return axios.post("/commissionReceived/excel/confirm/"+uuid)
};


export const cancelImportExcel = uuid =>{
    return axios.post("/commissionReceived/excel/cancel/"+uuid)
};

export const delImportExcel = uuid =>{
    return axios.post("/commissionReceived/excel/del/"+uuid)
};

export const queryCommRecImportExcelLogList = uuid => {
    return axios.get("/commissionReceived/excel/log/" + uuid)
};

export const queryCommissionLinkList = params => {
    return axios.get("/commissionReceived/link/list",{params:params})
};

export const insertCommissionLink = data => {
    return axios.post("/commissionReceived/link/insert",data)
};

export const delCommissionLink = uuid => {
    return axios.post("/commissionReceived/link/del/" + uuid)
};

export const queryListByCommissionLink = params => {
    return axios.get("/policyComm/link/list",{params:params})
};



export const queryListByCommissionLinkRec = params => {
    return axios.get("/commissionReceived/link/list/c",{params:params})
};


export const queryCommRecImportExcelResult = uuid => {
    return axios.get("/commissionReceived/result/"+uuid)
};



//=======================CommPromActiveStaff=========================
export const queryCommPromActiveStaffList = params => {
    return axios.get("/commProm/activeStaff/list",{params:params})
};

export const insertCommPromActiveStaff = data => {
    return axios.post("/commProm/activeStaff/insert",data)
};

export const updateCommPromActiveStaff = data => {
    return axios.post("/commProm/activeStaff/update",data)
};

export const delCommPromActiveStaff = uuid => {
    return axios.post("/commProm/activeStaff/del/"+uuid)
};

export const validCommPromActiveStaffIsExist = id => {
    return axios.get("/commProm/activeStaff/valid/"+id)
};

export const queryCommPromActiveStaffAllList = params => {
    return axios.get("/commProm/activeStaff/all",{params:params})
};



//=======================Contract=========================
export const queryCommNoticeList = params => {
    return axios.get("/commNotice", {params: params})
};

export const queryMyCommNoticeList = params => {
    return axios.get("/commNotice/my", {params: params})
};

export const insertCommNotice = data => {
    return axios.post("/commNotice/insert", data)
};

export const insertCommNoticeDirect = data => {
    return axios.post("/commNotice/insert/i", data)
};

export const updateCommNotice = data =>{
    return axios.post("/commNotice/update",data)
};

export const queryCommNoticeById = uuid => {
    return axios.get("/commNotice/" + uuid)
};

export const sendCommNoticeEmail = params =>{
    return axios.get("/commNotice/email",{params:params});
};

export const sendCommNoticePromEmail = params =>{
    return axios.get("/commNotice/prom/email",{params:params});
};

//=======================ContractCommProduct=========================

export const getCommContractList = params => {
    return axios.get("/contract/c/commContract/list", {params: params})
};

export const queryContractCommProductList = params => {
    return axios.get("/contract/c/commProduct", {params: params})
};


export const validContractCommProduct = params => {
    return axios.get("/contract/c/commProduct/valid/uuid", {params: params})
};
export const insertContractCommProduct = data => {
    return axios.post("/contract/c/commProduct/insert", data)
};


export const updateContractCommProduct = data =>{
    return axios.post("/contract/c/commProduct/update/uuid",data)
};


export const queryContractCommProductById = params => {
    return axios.get("/contract/c/commProduct/queryOne/uuid",{params:params})
};
export const copyContractProductBasicRate = params => {
    return axios.get("/contract/c/commProduct/copy",{params:params})
};
export const copyContractInsuranceCommission = params => {
    return axios.get("/contract/c/commProduct/insurance/copy",{params:params})
};

//=======================ContractCommStaffProduct=========================

export const queryContractCommOption = params =>{
    return axios.get("/contract/s/p/product/list",{params:params});
};

export const insertContractCommStaffProduct = data =>{
    return axios.post("/contract/s/p/insert",data);
};

export const queryContractCommStaffProductList = params =>{
    return axios.get("/contract/s/p/list",{params:params});
};

export const delContractCommStaffProductById = uuid =>{
    return axios.post("/contract/s/p/del/"+uuid);
};



//=======================Branch=========================
export const queryBranchList = params => {
    return axios.get("/hsbc/branch", {params: params})
};


export const validBranchCode = params => {
    return axios.get("/hsbc/branch/valid/name", {params: params})
};

export const insertBranch = data => {
    return axios.post("/hsbc/branch/insert", data)
};


export const updateBranch = data =>{
    return axios.post("/hsbc/branch/update",data)
};

export const queryBranchByUuid = uuid => {
    return axios.get("/hsbc/branch/" + uuid)
};

export const queryBranchOption = params => {
    return axios.get("/hsbc/branch/option",{params: params})
};


//=======================BranchReferrer=========================
export const queryBranchReferrerList = params => {
    return axios.get("/hsbc/branch/referrer", {params: params})
};


export const validBranchReferrerCode = params => {
    return axios.get("/hsbc/branch/referrer/valid/name", {params: params})
};

export const insertBranchReferrer = data => {
    return axios.post("/hsbc/branch/referrer/insert", data)
};


export const updateBranchReferrer = data =>{
    return axios.post("/hsbc/branch/referrer/update",data)
};

export const queryBranchReferrerByUuid = uuid => {
    return axios.get("/hsbc/branch/referrer/" + uuid)
};

export const queryBranchReferrerOption = params => {
    return axios.get("/hsbc/branch/referrer/option",{params: params})
};



//=======================WorkSchedule=========================
export const queryWorkScheduleList = params => {
    return axios.get("/hsbc/work/schedule/", {params: params})
};


export const validWorkScheduleCode = params => {
    return axios.get("/hsbc/work/schedule/valid/name", {params: params})
};

export const insertWorkSchedule = data => {
    return axios.post("/hsbc/work/schedule/insert", data)
};


export const updateWorkSchedule = data =>{
    return axios.post("/hsbc/work/schedule/update",data)
};

export const queryWorkScheduleByUuid = uuid => {
    return axios.get("/hsbc/work/schedule/" + uuid)
};

export const getBookingNo = params => {
    return axios.get("/hsbc/work/schedule/get/bookingNo",{params:params})
};

export const updateWorkScheduleRemarkStatus = data =>{
    return axios.post("/hsbc/work/schedule/status/update",data)
};

export const workScheduleFirstCheckPoint = data =>{
    return axios.post("/hsbc/work/schedule/approval/first/update",data)
};


export const linkWorkScheduleOa = params => {
    return axios.get("/hsbc/work/schedule/link/oa/ws",{params:params})
};


export const queryLinkWorkScheduleOa = uuid => {
    return axios.get("/hsbc/work/schedule/link/q/"+uuid);
};

export const queryOverseaIdForConvert = uuid => {
    return axios.get("/hsbc/work/schedule/link/p/c/"+uuid);
};

export const saveOverseaPolicyLink = params => {
    return axios.get("/hsbc/work/schedule/link/p/c/p",{params:params});
};


export const workScheduleLinkPolicy = data =>{
    return axios.post("/hsbc/work/schedule/linking",data)
};

export const workScheduleLinkPolicyUuid = data =>{
    return axios.post("/hsbc/work/schedule/linking/uuid",data)
};

export const cancelLinkPolicy = data =>{
    return axios.post("/hsbc/work/schedule/link/cancel",data)
};


export const linkPolicyOption = params => {
    return axios.get("/hsbc/work/schedule/linking/option",{params:params});
};



export const checkIsConvertOrNot = params => {
    return axios.get("/hsbc/work/schedule/linking/checking",{params:params});
};


export const validCustomerAndAppointmentDate = params => {
    return axios.get("/hsbc/work/schedule/customer/checking",{params:params});
};

export const queryIsmOption = params => {
    return axios.get("/hsbc/work/schedule/ism/option",{params:params});
};


export const deleteWorkSchedule = data =>{
    return axios.post("/hsbc/work/schedule/del",data)
};

//=======================InsuranceCutOff=========================
export const queryInsuranceCutOffList = params => {
    return axios.get("/hsbc/insurance/cutoff", {params: params})
};


export const validInsuranceCutOff = params => {
    return axios.get("/hsbc/insurance/cutoff/valid", {params: params})
};

export const insertInsuranceCutOff = data => {
    return axios.post("/hsbc/insurance/cutoff/insert", data)
};


export const updateInsuranceCutOff = data =>{
    return axios.post("/hsbc/insurance/cutoff/update",data)
};

export const queryInsuranceCutOffByUuid = uuid => {
    return axios.get("/hsbc/insurance/cutoff/" + uuid)
};


//=======================WorkScheduleLogBook=========================

export const queryExcelLogList = params => {
    return axios.get("/hsbc/workschedule/logbook/list", {params: params})
};


//=======================PosUploadLog=========================
export const queryPosUploadLogList = params => {
    return axios.get("/pos/upload/log/list", {params: params})
};


//=======================UserProductList=========================

export const queryUserProductList = params => {
    return axios.get("/user/product/list", {params: params})
};

export const insertUserProductList = data => {
    return axios.post("/user/product/list/insert", data)
};

export const removeUserProductList = data => {
    return axios.post("/user/product/list/remove", data)
};

export const updateInsertUserProductList = data => {
    return axios.post("/user/product/list/insert/update", data)
};

export const updateInsertUserProductListByUuid = data => {
    return axios.post("/user/product/list/insert/update/uuid", data)
};

export const updateRemoveUserProductList = data => {
    return axios.post("/user/product/list/remove/update", data)
};

export const addUserProductListIsNotDefaultList = data => {
    return axios.post("/user/product/list/default/used", data)
};

export const queryUserProductListIsNotDefaultList = params => {
    return axios.get("/user/product/list/default", {params: params})
};

export const updateUserRemovePeriodList = data => {
    return axios.post("/user/product/list/period/remove", data)
};


export const updateUserProductPeriodList = data => {
    return axios.post("/user/product/period/list/insert", data)
};



export const updateUserProductPeriodAddDate = data => {
    return axios.post("/user/product/period/list/update", data)
};




//=======================PolicyMonthPremium=========================

export const queryPolicyMonthPremiumList = params => {
    return axios.get("/policyMonthPremium", {params: params})
};

export const insertPolicyMonthPremium = data => {
    return axios.post("/policyMonthPremium/insert", data)
};

export const updatePolicyMonthPremium = data => {
    return axios.post("/policyMonthPremium/update", data)
};

export const delPolicyMonthPremium = data => {
    return axios.post("/policyMonthPremium/del", data)
};

export const validPolicyMonthPremiumYearNo = params => {
    return axios.get("/policyMonthPremium/valid", {params: params})
};



// WEBPACK FOOTER //
// ./src/api/api.js